import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.dataBuildToolJobLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.DataBuildToolJobLabel),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.DataBuildToolJobLabel)
    ]
})
export class DataBuildToolJobLinkedService extends LinkedService { }